import { ChevronDown } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Switch } from '@/components/ui/switch'

interface FieldVisibilityControlsProps {
  showDaysWithoutActivities: boolean
  onShowDaysWithoutActivitiesChange: (checked: boolean) => void
  visibleFields: Record<string, boolean>
  onVisibleFieldsChange: (fields: Record<string, boolean>) => void
}

export const FieldVisibilityControls = ({
  showDaysWithoutActivities,
  onShowDaysWithoutActivitiesChange,
  visibleFields,
  onVisibleFieldsChange,
}: FieldVisibilityControlsProps) => {
  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <label htmlFor="show-empty-days" className="text-muted-foreground text-sm">
          Leere Tage anzeigen
        </label>
        <Switch
          id="show-empty-days"
          checked={showDaysWithoutActivities}
          onCheckedChange={onShowDaysWithoutActivitiesChange}
        />
      </div>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="!shadow-none">
            Felder <ChevronDown className="ml-2 h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <DropdownMenuCheckboxItem
            checked={visibleFields['Tische'] ?? true}
            onCheckedChange={(checked) => {
              onVisibleFieldsChange({
                ...visibleFields,
                Tische: checked,
              })
            }}
          >
            Tische
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
            checked={visibleFields['Personen'] ?? true}
            onCheckedChange={(checked) => {
              onVisibleFieldsChange({
                ...visibleFields,
                Personen: checked,
              })
            }}
          >
            Personen
          </DropdownMenuCheckboxItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
